// extracted by mini-css-extract-plugin
export default {"spinner":"styles_spinner__4hHR+","spin":"styles_spin__YGNMX"};